import Api from 'utils/Api'

const GET_USER_CART_URL = `/cart/cart/`
const CREATE_BULK_CART_ITEM_URL = `/cart/cart_item/bulk_add/`
const CART_ITEM_ACTION_URL = `/cart/cart_item_action/`

const UPDATE_CART_URL = (id) => `/cart/cart/${id}/`
const DELETE_CART_ITEM_URL = (id) => `/cart/cart_item/${id}/`

export const GetUserCart = (params) => {
  return Api.get(GET_USER_CART_URL, {
    params: { ...params, channel: process.env.REACT_APP_CHANNEL_ID },
  })
}

export const GetSingleCart = (params) => {
  return Api.get(UPDATE_CART_URL(params.id), {
    params: { ...params, channel: process.env.REACT_APP_CHANNEL_ID },
  })
}

export const CartItemAction = (data) => {
  return Api.post(CART_ITEM_ACTION_URL, data)
}

export const BulkAddCartItem = (data) => {
  return Api.post(CREATE_BULK_CART_ITEM_URL, data)
}

export const DeleteUserCart = (params) => {
  return Api.delete(UPDATE_CART_URL(params.id), { params })
}

export const DeleteCartItem = (params) => {
  return Api.delete(DELETE_CART_ITEM_URL(params.id), { params })
}
